import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [statusMsg, setStatusMsg] = useState('');
  const [statusType, setStatusType] = useState<'success' | 'error' | ''>('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('website_alt') as string || '').trim();
    if (honeypotVal) {
      setStatusType('success');
      setStatusMsg(t('general.submitSuccess'));
      setEmail('');
      return;
    }

    try {
      const res = await fetch('http://szshops.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      if (res.ok) {
        setStatusType('success');
        setStatusMsg(t('general.submitSuccess'));
        setEmail('');
      } else {
        setStatusType('error');
        setStatusMsg(responseText || t('general.submitError'));
      }
    } catch {
      setStatusType('error');
      setStatusMsg(t('general.submitError'));
    }
  };

  const footerLinks = [
    {
      title: '快速链接',
      links: [
        { label: '首页', to: '/' },
        { label: '热门排行', to: '/category/all?sort=popular' },
        { label: '最新上架', to: '/category/all?sort=newest' },
        { label: '关于我们', to: '/about' },
      ],
    },
    {
      title: '分类浏览',
      links: [
        { label: '恋爱', to: '/category/romance' },
        { label: '奇幻', to: '/category/fantasy' },
        { label: '动作', to: '/category/action' },
        { label: '悬疑', to: '/category/thriller' },
      ],
    },
    {
      title: '帮助支持',
      links: [
        { label: '常见问题', to: '/about#faq' },
        { label: '用户协议', to: '/about#terms' },
        { label: '隐私政策', to: '/about#privacy' },
        { label: '联系我们', to: '/about#contact' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="px-6 md:px-10 py-14 md:py-16">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <h4 className="text-xl font-heading font-bold mb-3 tracking-wide">韩漫大全</h4>
            <p className="text-sm text-background-50/70 leading-relaxed mb-6 max-w-sm">
              {t('footer.subscribeDesc')}
            </p>
            <form
             
              onSubmit={handleSubscribe}
              className="flex flex-col gap-3"
            >
              <label className="text-xs text-background-50/60 font-medium">
                {t('footer.subscribeTitle')}
              </label>
              <div className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('footer.subscribePlaceholder')}
                  className="flex-1 bg-transparent border-b border-background-50/30 text-sm text-background-50 placeholder:text-background-50/40 py-2 outline-none focus:border-background-50/70 transition-colors"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap px-5 py-2 border border-background-50/30 rounded-full text-sm text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer"
                >
                  {t('footer.subscribeBtn')}
                </button>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="anti-spam-field"
              />
              {statusMsg && (
                <p className={`text-xs mt-1 ${statusType === 'success' ? 'text-accent-300' : 'text-primary-300'}`}>
                  {statusMsg}
                </p>
              )}
            </form>
          </div>

          <div className="lg:w-[60%] grid grid-cols-3 gap-8">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h5 className="text-sm font-semibold mb-4 text-background-50">{col.title}</h5>
                <ul className="flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-background-50/60 hover:text-background-50/90 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="px-6 md:px-10 py-5 max-w-[1280px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">{t('footer.copyright')}</p>
          <p className="text-xs text-background-50/40">
            <span className="mr-4">{t('footer.contactEmail')}</span>
            <span>{t('footer.contactAddress')}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}